import React, {Component} from 'react';
import Select from 'react-select';

class MentorRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      disabled: false,
    };
  }

  componentDidMount() {
    const {row} = this.props;
    this.checkStateRow(row)
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const {row} = this.props;
    if (prevProps.row.mentor_email !== row.mentor_email) {
      this.checkStateRow(row)
    }
  }

  checkStateRow = (row) => {
    if (typeof row.mentor_email === 'string' && row.mentor_email.length > 0) {
      this.setState({value: row.mentor_email, disabled: true});
    } else if (!row.mentor_email) {
      this.setState({ disabled: false, value: null });
    }
  }

  onChange = (event) => {
    this.setState({ value: event ? event.value : null });
  }

  setValue = (row) => () => {
    const {value } = this.state;
    const {setMentor} = this.props;
    if (typeof value === 'string' && value.length > 0 && Number(row.process_id) > 0) {
      setMentor(row.process_id, value);
    }
  }

  render() {
    const {mentors, row, settingMentorIsDisable = false} = this.props;
    const selectedMentor = mentors.find(mentor => mentor.sk_user_email === row.mentor_email)

    return !row.mentor_confirmed && !settingMentorIsDisable ? (
      <div className="input-group" onClick={event => event.stopPropagation()}>
        <Select
          autosize={false}
          name="form-field-name"
          className="has-success"
          placeholder="Выбрать исполнителя"
          value={this.state.value}
          disabled={!!this.state.disabled}
          style={{width: "100%", borderColor: "#ccc"}}
          onChange={this.onChange}
          options={mentors.map((mentor) => ({
            value: mentor.sk_user_email,
            label: [mentor.mentor_last_name, mentor.mentor_first_name].join(' ')
          }))}
        />
        {this.state.disabled ? (
            <button
                type="button"
                className="btn btn-default"
                onClick={() => this.setState({disabled: false})}
            >
              Переазначить
            </button>
        ) : (
          <button type="button" className="btn btn-success" onClick={this.setValue(row)}>Назначить</button>
        )}
      </div>
    ) : (<div>{selectedMentor ? [selectedMentor.mentor_last_name, selectedMentor.mentor_first_name].join(' ') : ''}</div>)
  }
}

export default MentorRow;
